import { render } from "./unread_notification.vue?vue&type=template&id=0a7127a6"
import script from "./unread_notification.vue?vue&type=script&lang=js"
export * from "./unread_notification.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__